import { useState, useEffect, useRef } from 'react'
import { Trash2, Pause, Play } from 'lucide-react'
import { getLogs, clearLogs, subscribeLogs } from '../stores/sipStore'

const LEVEL_STYLE = {
  info: 'text-slate-300',
  warn: 'text-yellow-300',
  error: 'text-rose-300',
}

export default function LogViewer() {
  const [logs, setLogs] = useState(getLogs())
  const [paused, setPaused] = useState(false)
  const scrollRef = useRef(null)
  const pausedRef = useRef(paused)
  pausedRef.current = paused

  useEffect(() => {
    const unsub = subscribeLogs(() => {
      if (!pausedRef.current) setLogs(getLogs())
    })
    return unsub
  }, [])

  useEffect(() => {
    if (!paused && scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
  }, [logs, paused])

  return (
    <div className="bg-slate-950/60 border border-line rounded-xl overflow-hidden">
      <div className="flex items-center justify-between px-3 py-2 border-b border-line">
        <h3 className="text-sm font-semibold text-mute">לוגים חיים <span className="text-xs">({logs.length})</span></h3>
        <div className="flex gap-1">
          <button
            onClick={() => setPaused(p => !p)}
            className="p-1.5 rounded hover:bg-line/40 text-mute"
            title={paused ? 'המשך' : 'השהה'}
          >
            {paused ? <Play size={14} /> : <Pause size={14} />}
          </button>
          <button
            onClick={() => { clearLogs(); setLogs([]) }}
            className="p-1.5 rounded hover:bg-line/40 text-mute"
            title="נקה לוגים"
          >
            <Trash2 size={14} />
          </button>
        </div>
      </div>
      <div ref={scrollRef} className="overflow-y-auto h-64 text-xs font-mono p-2 space-y-0.5 ltr">
        {logs.length === 0 ? (
          <div className="text-mute text-center py-8">אין לוגים עדיין</div>
        ) : (
          logs.map((l, i) => (
            <div key={i} className={LEVEL_STYLE[l.level] || 'text-slate-300'}>
              <span className="text-mute">{l.t.slice(11, 19)}</span>{' '}
              <span className="opacity-70">[{l.level}]</span>{' '}
              {l.msg}
            </div>
          ))
        )}
      </div>
    </div>
  )
}
